import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SharedDataService } from '../../service/shared-data.service';

@Component({
  selector: '.related-story-listing',
  templateUrl: './related-story-listing.component.html',
  styleUrls: ['./related-story-listing.component.scss']
})
export class RelatedStoryListingComponent implements OnInit {

  @Input() chooseMultiple: boolean;
  @Input() relatedStoryType: string;
  @Input() showNextButton : boolean;
  @Input()
  set storyId(storyId_string: number) {
    this.story_Id = (storyId_string) ? storyId_string : null;
  }


  @Input()
  set exclusionList(exclusionList: any[]) {
    // console.log(exclusionList);
    this.storyIdList = (exclusionList && (exclusionList.length > 0)) ? exclusionList : [];
  }
  @Output() sendIdListToParentfn = new EventEmitter<any>();
  @Output() openEditRelatedStoryPopupData  = new EventEmitter<any>();
  @Output() closePopupEmit = new EventEmitter<any>();
  @Output() sendObjListToParentFn = new EventEmitter<any>();
  @Output() sendRelatedStoryData = new EventEmitter<any>();
  @Output() sendRelatedStoryDataHowto = new EventEmitter<any>();
  @Output() sendAlsoReadData = new EventEmitter<any>();
  storyIdList = [];
  storyData = [];
  story_Id: number;
  domainConfig:{};
  enableRelatedStoryPreview:boolean;
  constructor(private sharedService: SharedDataService) {
    
    // console.log('related listing constructor');
   }

  ngOnInit() {
    this.domainConfig = this.sharedService.currentDomainConfiguration;
     // console.log('related story init' + this.story_Id);
     this.enableRelatedStoryPreview = this.domainConfig['config']['story']['enableRelatedStoryPreview']

  }

  storiesSelected() {
    if(this.relatedStoryType=='howto'){
      this.getRelatedStoryhowtoTypeData(this.storyIdList)
    } else if(this.relatedStoryType == 'alsoread') {
      this.sendAlsoReadData.emit(this.storyIdList)
    } else if(this.relatedStoryType == 'web-story') {
      this.sendRelatedStoryData.emit(this.storyData);
    } else {
      this.sendIdListToParentfn.emit(this.storyIdList);
    }
  }

  openEditRelatedStoryPopup(){
    this.openEditRelatedStoryPopupData.emit(this.storyIdList);
    this.closePopupEmit.emit(null);
  }

  storySelected(ev) {
    if (ev.type === 'multiple') {
      this.storyIdList = ev.id;
    } else if (ev.type === 'single') {
      this.storyIdList = [ev.id];
      // console.log('came here');
      if(this.relatedStoryType == 'howto') {
        this.getRelatedStoryhowtoTypeData(ev.id)
      } else {
        this.sendIdListToParentfn.emit(ev.id);
      }
      this.sendObjListToParentFn.emit(ev);
    }
  }
  getRelatedStoryGalleryTypeData(ev){
    console.log('getRelatedStoryGalleryTypeData',ev)
    if(this.relatedStoryType == 'web-story') {
      this.storyData = ev.data;
    } else {
      this.sendRelatedStoryData.emit(ev);
    }
  }
  getRelatedStoryhowtoTypeData(ids){
    console.log('getRelatedStoryHowtoTypeData section',ids)
    this.sendRelatedStoryDataHowto.emit(ids);
  }
  closePopup() {
    this.closePopupEmit.emit(null);
  }

}
